export default __webpack_public_path__ + "static/media/nun.3c458514.jpg";